export function isBotRequest() {
  return /visualregressiontesting|bot|chrome-lighthouse|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent.toLowerCase());
}
